export const SET_YES_NO_SELECTED = "SET_YES_NO_SELECTED";
export const SET_YES_NO_SELECTED_OPTION = "SET_YES_NO_SELECTED_OPTION";

export const setYesNoSelected = (selected) => ({
    type: SET_YES_NO_SELECTED,
    payload: selected,
});

export const setYesNoSelectedOption = (option) => ({
    type: SET_YES_NO_SELECTED_OPTION,
    payload: option,
});
